export const EVIRPX_ENABLED = 'evir-px-enabled'
export const INSPECTION_ALERT_TYPE = 'Inspection'